import { __decorate } from "tslib";
import Avatar from "@/components/Avatar.vue";
import CustomerCard from "@/components/CustomerCard.vue";
import FilePreview from '@/components/FilePreview.vue';
import { Component, Emit, Prop } from "vue-property-decorator";
import Vue from "vue";
import PrettyBytes from "@/filters/pretty-bytes";
import ConfirmableButton from '@/components/ConfirmableButton.vue';
import { mapState } from 'vuex';
let MediaItemsList = class MediaItemsList extends Vue {
    loading;
    medias;
    showCustomer;
    isRemovePending;
    removingId;
    size(media) {
        return PrettyBytes(media.size);
    }
    openModal(model) {
        return model;
    }
    deleteItem(media) {
        this.removingId = media._id;
        return media;
    }
};
__decorate([
    Prop({ type: Boolean, required: true })
], MediaItemsList.prototype, "loading", void 0);
__decorate([
    Prop({ type: Array, required: true })
], MediaItemsList.prototype, "medias", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], MediaItemsList.prototype, "showCustomer", void 0);
__decorate([
    Emit('openModal')
], MediaItemsList.prototype, "openModal", null);
__decorate([
    Emit('deleteItem')
], MediaItemsList.prototype, "deleteItem", null);
MediaItemsList = __decorate([
    Component({
        components: {
            Avatar,
            CustomerCard,
            FilePreview,
            ConfirmableButton
        },
        computed: {
            ...mapState('media', { isRemovePending: 'isRemovePending' })
        }
    })
], MediaItemsList);
export default MediaItemsList;
